<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="card">
    <div class="row ml-1 mt-1">
        <!-- Teklif Ekle Butonu -->
        <a href="#/admin/create-fixtures" class="mb-1">
            <button class="btn btn-primary" rippleEffect>
                <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                Demirbaş Alış
            </button>
        </a>
    
        <!-- Arama Kutusu ve Select -->
        <div class="ml-auto d-flex align-items-center">
            <!-- Arama Kutusu -->
            <div class="form-group mr-2">
                <label class="d-flex align-items-center">
                    <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </label>
            </div>
    
            <!-- Select -->
            <div>
                <label class="d-flex mb-1 mr-2">
                    <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
        </div>
    </div>
 
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Ürün Adı" prop="productName" [width]="150"></ngx-datatable-column>
        <ngx-datatable-column name="Fiyat" prop="price" class="ellipsis-column" [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="İndirim" prop="discountRate" class="ellipsis-column"
            [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="Adet" prop="count" class="ellipsis-column" [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="Vergi" prop="taxRate" class="ellipsis-column" [width]="50"></ngx-datatable-column>
        <ngx-datatable-column name="Toplam Fiyat" [width]="100">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{totalPrice(row.price,row.taxRate,row.discountRate) ?? 'Yok' }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Seri No" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.serialNo ?? 'Yok' }}
            </ng-template>
        </ngx-datatable-column>

        <!-- <ngx-datatable-column [width]="40" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <div ngbDropdown container="body">
                      <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                        <span [data-feather]="'more-vertical'" [class]="'cursor-pointer'"></span>
                      </button>
                      <div ngbDropdownMenu>
                        <a href="#/admin/company/{{row.id}}" ngbDropdownItem
                          class="d-flex align-items-center"><i data-feather="file-text" class="mr-50"></i>Görüntüle</a>
                         <a href="javascript:;" ngbDropdownItem
                            ><span [data-feather]="'trash'" [size]="16" [class]="'mr-50'"></span> Delete</a
                          > 
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column> -->
        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>

                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>